module.exports = __webpack_public_path__ + "images/sales_contact_suggestion/feel_free_0c1234b348d2f556518df18647204bc8.svg";